module.exports = __webpack_public_path__ + "static/img/logo_1副本.6123374.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_1副本.png
// module id = uNL6
// module chunks = 0